export default __webpack_public_path__ + "static/cNzETLeB-45fad5cfe20a5305088ecc814f83b88a.svg";